import { Component, h, signal, tag } from "omi";

import { Store } from "@/store";
import { tailwind } from "@/tailwind";

import { NWQuizQuestionView } from "./views/question";
import { NWQuizStatusView } from "./views/status";
import { createQuizStore } from "./store";

type Props = {};

@tag("nw-quiz-app")
export class NWQuizApp extends Component<Props> {
  static css = [
    tailwind,
    `
    @keyframes fadeIn {
      from { opacity: 0; }
      to { opacity: 1; }
    }
    
    @keyframes fadeOut {
      from { opacity: 1; }
      to { opacity: 0; }
    }
    
    .fade-in {
      animation: fadeIn 300ms ease-in-out forwards;
    }
    
    .fade-out {
      animation: fadeOut 300ms ease-in-out forwards;
    }
    
    .transition-container {
      position: relative;
    }
    
    .transition-item {
      transition: all 300ms ease-in-out;
    }
    `,
  ];

  private quizStore = createQuizStore();
  private showQuestion = signal<boolean>(false);
  private showStatus = signal<boolean>(true);
  private statusFadingOut = signal<boolean>(false);

  provide = {
    quizStore: this.quizStore,
  };

  installed() {
    const projectId = Store.project.id.value;
    const trackId = Store.project.getSelectedTrackId();

    if (projectId != null && trackId != null) {
      this.quizStore.fetchQuiz().then(() => {
        const activeQuestion = this.quizStore.getActiveQuestion();
        const hasActiveQuestion = activeQuestion != null;
        this.updateViewVisibility(hasActiveQuestion);
      });
    }
  }

  private updateViewVisibility(hasActiveQuestion: boolean): void {
    if (hasActiveQuestion && !this.showQuestion.value) {
      this.statusFadingOut.value = true;

      setTimeout(() => {
        this.statusFadingOut.value = false;
        this.showStatus.value = false;
        this.showQuestion.value = true;
      }, 200);
    } else if (!hasActiveQuestion && !this.showStatus.value) {
      this.showQuestion.value = false;
      this.showStatus.value = true;
    }
  }

  render() {
    const quiz = this.quizStore.quiz.signal.data.value;
    const activeQuestion = this.quizStore.getActiveQuestion();
    this.updateViewVisibility(activeQuestion != null);

    return (
      <div className="max-w-2xl mx-auto py-16">
        <div className="transition-container">
          {(this.showStatus.value || this.statusFadingOut.value) && (
            <div className={`transition-item ${this.statusFadingOut.value ? "fade-out" : "fade-in"}`}>
              <NWQuizStatusView quiz={quiz} />
            </div>
          )}

          {this.showQuestion.value && activeQuestion?.question && (
            <div className="transition-item fade-in">
              <NWQuizQuestionView questionNumber={(activeQuestion.index ?? 0) + 1} question={activeQuestion.question} />
            </div>
          )}
        </div>
      </div>
    );
  }
}
